import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { SelectOption, UTMReadingItem } from '../../../utils/models';
import { matchPhrases } from '../../../utils/utilities';
import { OTHER_DESCRIPTION, UTM_READING_ITEM_AFFIX } from '../../../utils/constants';

import toastService from '../../../services/toastService';

class CustomUTMSummaryEditReadingItem extends Form {
	state = {
		data: { srNo: 0, thickness: '', option: '', otherOption: '' },
		errors: {},
		loading: false,
		progress: 0,
		thicknessMeasurementOptions: [],
	};

	schema = {
		srNo: Joi.number().required().label('Sr. No'),
		thickness: Joi.number().min(0).required().label('Thickness'),
		option: Joi.string().min(1).required().label('Thickness Readings'),
		otherOption: Joi.string().when('option', {
			is: OTHER_DESCRIPTION,
			then: Joi.string().min(3).required().label('Thickness Reading Description'),
			otherwise: Joi.string().allow('').label('Thickness Reading Description'),
		}),
	};

	static propTypes = {
		options: PropTypes.array,
		reading: PropTypes.object,
		readings: PropTypes.array,
		onEdit: PropTypes.func,
		onCancelEdit: PropTypes.func,
	};

	componentDidMount() {
		this.mapInitialReading();
	}

	mapInitialReading = () => {
		const optionMatch = this.props.options.find((option: SelectOption) => matchPhrases(option.id.toString(), this.props.reading.option));

		this.setState({
			data: {
				srNo: this.props.reading.srNo,
				thickness: this.props.reading.thickness,
				option: optionMatch ? optionMatch.id : OTHER_DESCRIPTION,
				otherOption: this.props.reading.option,
			},
			thicknessMeasurementOptions: this.props.options,
		} as any);
	};

	doSubmit = (): void => {
		const optionLabel = this.getOptionLabel();
		if (matchPhrases(optionLabel, OTHER_DESCRIPTION)) return toastService.error('Please specify the option!');

		this.props.onEdit({
			srNo: this.state.data.srNo,
			label: `${this.state.data.thickness} ${UTM_READING_ITEM_AFFIX} ${this.getOptionLabel()}`,
			thickness: this.state.data.thickness, 
			option: this.getOptionLabel()
		});
	};

	getOptionLabel = () => {
		if (this.state.data.option === OTHER_DESCRIPTION) {
			return this.state.data.otherOption;
		}

		return this.state.data.option;
	};

	getThicknessOptions = () => {
		return this.state.thicknessMeasurementOptions.filter((option: SelectOption) => {
			const readingEntry = this.props.readings.filter((reading: UTMReadingItem) => reading.srNo !== this.state.data.srNo)
													.find((reading: UTMReadingItem) => matchPhrases(option.id.toString(), reading.option));

			return !readingEntry;
		});
	};

	render() {
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="container">
					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'number',
								name: 'thickness',
								label: 'Thickness',
								placeholder: 'Enter Thickness (mm)',
							})}
						</div>
						<div className="col d-flex align-items-center justify-content-center">
							{UTM_READING_ITEM_AFFIX}
						</div>
						<div className="col">
							{this.renderSelect({
								options: this.getThicknessOptions(),
								name: 'option',
								placeholder: 'Select Thickness Option',
								label: 'Thickness Option',
							})}
						</div>
						<Conditional isVisible={this.state.data.option === OTHER_DESCRIPTION}>
							<div className="col">
								{this.renderInput({
									name: 'otherOption',
									type: 'text',
									placeholder: 'Enter Thickness Option Description',
									label: 'Thickness Option Description',
								})}
							</div>
						</Conditional>
					</div>

					<div className="d-flex justify-content-end">
						<div className="me-4">
							{this.renderButton('Save Changes')}
						</div>

						<Button 
							label='Cancel' 
							style={{ backgroundColor: 'red' }}
							onClick={this.props.onCancelEdit} 
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default CustomUTMSummaryEditReadingItem;
